export default "__VITE_ASSET__DYMOqf7C__"